import React, { Suspense, useEffect, useState } from 'react'
import dayjs from 'dayjs'
import classNames from 'classnames'
import styles from './salary.module.scss'
import { salaryTabs } from './salary.tabs'
import { TabsUi } from '../../ui/TabsUi/TabsUi'
import { useAppDispatch } from '../../../store/hooks'
import { Outlet, useLocation } from 'react-router-dom'
import useCurrentTab from '../../../hooks/useCurrentTab'
import { getPrice } from '../../../store/currency/thunk'
import PageSpinner from '../../ui/PageSpinner/PageSpinner'
import DatePickerUi from '../../ui/DatePickerUi/DatePickerUi'
import { IconBitcoin, IconDollar } from '../../../utils/icons'
import { useCurrencySelector } from '../../../store/selectors/currency'
import { SalaryWeekContext } from '../../../context/salaryWeek.context'
import { SalaryStatusesContext } from '../../../context/salaryStatuses.context'
import { SalaryTransferContext } from '../../../context/salaryTransfer.context'
import { SalaryCryptoDto } from '../../../pages/Salary/SalaryCrypto/SalaryCryptoPage'

const SalaryLayout: React.FC = () => {
  const dispatch = useAppDispatch()
  const { btc, usd } = useCurrencySelector()
  const { pathname } = useLocation()
  const activeTab = useCurrentTab(pathname, salaryTabs)
  const [weekFilter, setWeekFilter] = useState<dayjs.Dayjs | null>(dayjs().startOf('week'))
  const [salaryStatuses, setSalaryStatuses] = useState({ isConfirm: false, isPreview: true })
  const [salaryTransfer, setSalaryTransfer] = useState<SalaryCryptoDto>()

  useEffect(() => {
    dispatch(getPrice()).then()
  }, [])

  return (
    <>
      <div className={styles.container}>
        <>
          <div className={styles.title}>Бухгалтерия</div>
          <div className={styles.weekSelect}>
            <p>Выбор недели:</p>
            <DatePickerUi
              allowClear={false}
              onChange={(month) => setWeekFilter(month)}
              picker='week'
              value={dayjs(weekFilter)} // Convert dayjs.Dayjs to Dayjs
            />
          </div>
          <div className={styles.curse}>
            <span className={styles.curseTitle}>
              <IconBitcoin width='18' height='18' fill='var(--color-main)' />
              Курс BTC:
            </span>
            <span className={styles.valueCurse}>{btc} $</span>
            <span className={styles.curseTitle}>
              <IconDollar width='18' height='18' fill='var(--color-main)' />
              Курс USD:
            </span>
            <span>{usd} грн</span>
          </div>
        </>
      </div>
      <div className={styles.containerTabs}>
        <TabsUi
          className={classNames(styles.TabsUi, styles['style'])}
          defaultActiveKey='0'
          activeKey={String(activeTab)}
          items={salaryTabs.map((el, index) => ({
            label: el.title,
            key: String(index),
          }))}
        />
      </div>
      <SalaryWeekContext.Provider value={{ weekFilter, setWeekFilter }}>
        <SalaryStatusesContext.Provider value={{ salaryStatuses, setSalaryStatuses }}>
          <SalaryTransferContext.Provider value={{ salaryTransfer, setSalaryTransfer }}>
            <Suspense fallback={<PageSpinner className={styles.loadSpin} />}>
              <Outlet />
            </Suspense>
          </SalaryTransferContext.Provider>
        </SalaryStatusesContext.Provider>
      </SalaryWeekContext.Provider>
    </>
  )
}

export default SalaryLayout
